<form [formGroup]="mainForm">
  <h1>{{ organizationDetails.OrganizationName }}</h1>
  <div class="p-grid p-fluid no-margin">
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div [ngClass]="{'jp-card-visa' : ccType === 'Visa', 'jp-card-mastercard' : ccType === 'Mastercard',
      'jp-card-discover' : ccType === 'Discover', 'jp-card-ames' : ccType === 'amex', 'jp-card-flipped' : flipped}" class="jp-card">
        <div class="jp-card-front">
          @switch (ccType) {
            @case ('Visa') {
              <div class="jp-card-logo jp-card-visa">Visa</div>
            }
            @case ('Mastercard') {
              <div class="jp-card-logo jp-card-mastercard">Mastercard</div>
            }
            @case ('Discover') {
              <div class="jp-card-logo jp-card-discover">discover</div>
            }
            @case ('amex') {
              <div class="jp-card-logo jp-card-amex"></div>
            }
          }

          <div class="jp-card-lower">
            <div class="jp-card-shiny"></div>
            <div class="jp-card-cvc jp-card-display jp-card-invalid">•••</div>
            <div class="jp-card-number jp-card-display jp-card-invalid">

              @if (mainForm.get('cc').value) {
                {{ mainForm.get('cc').value | creditCard }}
              } @else {
                •••• •••• •••• ••••
              }
            </div>
            <div class="jp-card-name jp-card-display jp-card-invalid">
              @if (mainForm.get('fullName').value) {
                {{ mainForm.get('fullName').value }}
              } @else {
                John Smith
              }

            </div>
            <div class="jp-card-expiry jp-card-display jp-card-invalid" data-after="valid
thru" data-before="MM/YY">
              @if (mainForm.get('expMonth').value) {
                {{ mainForm.get('expMonth').value }}
              } @else {
                ••
              } /
              @if (mainForm.get('expYear').value) {
                {{ mainForm.get('expYear').value }}
              } @else {
                ••
              }


            </div>
          </div>
        </div>
        <div class="jp-card-back">
          <div class="jp-card-bar"></div>
          <div class="jp-card-cvc jp-card-display jp-card-invalid">
            @if (mainForm.get('verificationNumber').value) {
              {{ mainForm.get('verificationNumber').value }}
            } @else {
              •••
            }
          </div>
          <div class="jp-card-shiny"></div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
      <label class="registration-label">Name as it appears on card<sup class="req">*</sup></label>
      <input formControlName="fullName" pInputText type="text"/>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
      <label class="registration-label">Credit/Debit Card<sup class="req">*</sup></label>
      <input (keydown)="removeSpaces($event)" formControlName="cc" maxlength="16" pInputText type="text"/>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
      <label class="registration-label">Exp. Month (2 digits)<sup class="req">*</sup></label>
      <input (keydown)="numberOnly($event)" col-xs-12 formControlName="expMonth" maxlength="2" pInputText type="text"/>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
      <label class="registration-label">Exp. Year (2 digits)<sup class="req">*</sup></label>
      <input (keydown)="numberOnly($event)" formControlName="expYear" maxlength="2" pInputText type="text"/>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
      <label class="registration-label">Verification #<sup class="req">*</sup></label>
      <input (blur)="flipped = false" (focus)="flipped = true" (keydown)="numberOnly($event)" formControlName="verificationNumber" maxlength="4" pInputText
             type="text"/>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
      <!--      <p-checkbox formControlName="recurring" [value]="true" binary="true" />-->
      <label class="registration-label">Your credit/debit card will be charged on a recurring monthly basis for your membership dues</label>
    </div>
    <div class="contribution">
      Amount Due Now: ${{ organizationDetails.ChargeAmount }}
    </div>
    <div class="next-page-button">
      <p-button (click)="goToNextPage()" [disabled]="mainForm.invalid" label="Next"/>
    </div>
  </div>
</form>
